import script from "./advance-salary-request.vue?vue&type=script&lang=ts&setup=true"
export * from "./advance-salary-request.vue?vue&type=script&lang=ts&setup=true"

import "./advance-salary-request.vue?vue&type=style&index=0&id=056bb9c7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-056bb9c7"]])

export default __exports__